// Meal food category colors, shared by the plan grid, meal modal, previews and print.
// Screens read them as CSS variables (--meal-category-N / --meal-category-N-text).
export const CATEGORY_SCHEMES = {
    classic: {
        1: {bg: '#1abc9c', text: '#ffffff'},
        2: {bg: '#f7b84b', text: '#242424'},
        3: {bg: '#f672a7', text: '#ffffff'},
        4: {bg: '#3155A6', text: '#ffffff'},
        5: {bg: '#d3d3d3', text: '#242424'},
        6: {bg: '#0891b2', text: '#ffffff'},
    },
    deep: {
        1: {bg: '#0f8a71', text: '#ffffff'},
        2: {bg: '#f7b84b', text: '#242424'},
        3: {bg: '#d63f7c', text: '#ffffff'},
        4: {bg: '#3155A6', text: '#ffffff'},
        5: {bg: '#d3d3d3', text: '#242424'},
        6: {bg: '#0891b2', text: '#ffffff'},
    },
};

export const DEFAULT_CATEGORY_SCHEME = 'deep';

export const getCategoryScheme = name => CATEGORY_SCHEMES[name] || CATEGORY_SCHEMES[DEFAULT_CATEGORY_SCHEME];

// Category 1..6 backgrounds, for charts that take literal colors.
export const getCategoryColorList = name => Object.values(getCategoryScheme(name)).map(({bg}) => bg);

// Category rules for the print document, which doesn't get the app's CSS variables. Print colours
// categories 1–5 only, as the print preview and the template editor do.
export const getCategoryPrintStyles = name => Object.entries(getCategoryScheme(name))
    .filter(([category]) => category <= 5)
    .map(([category, {bg, text}]) =>
        `.meal-category-${category}{color:${text}!important;background-color:${bg}!important;margin: 2px;padding: 1px;}`
    ).join('');

export const applyCategoryScheme = name => {
    const root = document.documentElement.style;
    for (const [category, {bg, text}] of Object.entries(getCategoryScheme(name))) {
        root.setProperty(`--meal-category-${category}`, bg);
        root.setProperty(`--meal-category-${category}-text`, text);
    }
};
